import React from "react";

const BASE = "https://furni.franklyorigins.net/api/furniture/render";

export const CURRENCY_TIERS = [
    {
        furni: "habloonbar",
        value: 50,
        iconUrl: `${BASE}?furni=s_CF_50_goldbar&direction=0&state=1&frame=0&width=120&height=120`,
    },
    {
        furni: "sackofhabloons",
        value: 20,
        iconUrl: `${BASE}?furni=s_CF_20_moneybag&direction=2&state=1&frame=0&width=120&height=120`,
    },
    {
        furni: "goldenhabloon",
        value: 10,
        iconUrl: `${BASE}?furni=s_CF_10_coin_gold&direction=0&state=1&frame=0&width=120&height=120`,
    },
    {
        furni: "silverhabloon",
        value: 5,
        iconUrl: `${BASE}?furni=s_CF_5_coin_silver&direction=0&state=1&frame=0&width=120&height=120`,
    },
    {
        furni: "bronzehabloon",
        value: 1,
        iconUrl: `${BASE}?furni=s_CF_1_coin_bronze&direction=0&state=1&frame=0&width=120&height=120`,
    },
];

export const breakdownHabloons = (total) => {
    const result = [];
    let remaining = Math.floor(Number(total) || 0);
    for (const tier of CURRENCY_TIERS) {
        const count = Math.floor(remaining / tier.value);
        if (count > 0) {
            result.push({ ...tier, count });
            remaining -= count * tier.value;
        }
    }
    return result;
};

// size: 'sm' | 'md' | 'lg'
export default function CurrencyBreakdown({ value, size = "md" }) {
    const breakdown = breakdownHabloons(value);
    if (!breakdown.length) return <span className="text-gray-600 text-lg">—</span>;

    const textCls =
        size === "sm"
            ? "font-['Jersey_10'] text-lg leading-none"
            : size === "lg"
            ? "font-['Jersey_10'] text-lg leading-none"
            : "font-['Jersey_10'] text-lg leading-none";

    return (
        <div className="flex flex-wrap gap-1 items-center">
            {breakdown.map(({ furni, iconUrl, count }) => (
                <div key={furni} className="flex items-center gap-0.5">
                    <img
                        src={iconUrl}
                        alt={furni}
                        draggable={false}
                        style={{
                            imageRendering: "pixelated",
                            width: "auto",
                            height: "auto",
                            maxWidth: "none",
                            maxHeight: "none",
                        }}
                    />
                    <span className={textCls}>x{count}</span>
                </div>
            ))}
        </div>
    );
}
